import React from "react";
import {
  CheckCircleFill,
  ArrowClockwise,
  XCircleFill,
} from "react-bootstrap-icons";
import { CustomersIcon } from "../../../assets/icons/iconsProvider";
import { isSpinnerEnabled, LoadingIndicator } from "../../utility";
import Button from "../Buttons/Button";
import {
  buttonTypeConstants,
  customerConstants,
  storeConstants,
} from "../../../constants";
import { connect } from "react-redux";
import { storeActions } from "../../../redux/actions";
import Skeleton from "react-loading-skeleton";

const ShopifyCustomerSyncing = ({
  currentStore,
  spinnerArray,
  getUpdatedCurrentStoreDetails,
  triggerCustomerSyncWithShopify,
}) => {
  const handleRefresh = () => {
    // getUpdatedCurrentStoreDetails(currentStore?.id);
    triggerCustomerSyncWithShopify({ storeId: currentStore?.id });
  };

  const isLoading = isSpinnerEnabled(
    spinnerArray,
    storeConstants.GET_STORE_BY_ID
  );
  const shopify = currentStore?.shopify;
  const syncingStatus = shopify?.isShopifyCustomerSyncing;

  if (isLoading) {
    return (
      <div className="d-flex align-items-center p-3 customer-syncing-card">
        <div className="me-3">
          <Skeleton circle width={40} height={40} />
        </div>
        <div className="flex-grow-1">
          <div className="fw-bold">
            <Skeleton width={80} height={16} />
          </div>
          <div className="text-muted d-flex align-items-center mt-1">
            <Skeleton width={150} height={20} />
          </div>
        </div>
        <div className="ms-2">
          <Skeleton circle width={24} height={24} />
        </div>
      </div>
    );
  }

  if (!shopify) return null;

  const getStatusContent = () => {
    if (syncingStatus === true) {
      return (
        <>
          <LoadingIndicator color="text-black" />
          <span>Syncing in process</span>
        </>
      );
    }
    if (syncingStatus === customerConstants.CUSTOMER_SYNCING_ERROR) {
      return "Sync Failed";
    }
    return "Sync succeeded";
  };

  const getStatusIcon = () => {
    let statusIcon = null;
    if (syncingStatus === true) {
      statusIcon = <LoadingIndicator color="text-black" />;
    } else if (syncingStatus === customerConstants.CUSTOMER_SYNCING_ERROR) {
      statusIcon = (
        <Button
          IconImage={ArrowClockwise}
          handleClick={handleRefresh}
          className="batch-delete-button"
          buttonType={buttonTypeConstants.BLACK_BUTTON}
        />
      );
    } else {
      statusIcon = <CheckCircleFill color="green" size={20} />;
    }
    return statusIcon;
  };

  return (
    <div className="d-flex align-items-center p-3 customer-syncing-card">
      <div className="me-3">
        <CustomersIcon />
      </div>
      <div className="flex-grow-1">
        <div className="fw-bold">Customer</div>
        <div className="text-muted">{getStatusContent()}</div>
      </div>
      <div className="ms-2">{getStatusIcon()}</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
});

const mapDispatchToProps = (dispatch) => ({
  getUpdatedCurrentStoreDetails: (storeId) =>
    dispatch(storeActions.getUpdatedCurrentStoreDetails(storeId)),
  triggerCustomerSyncWithShopify: (data) =>
    dispatch(storeActions.triggerCustomerSyncWithShopify(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShopifyCustomerSyncing);
